<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 text-center">
      <p>{{texto}}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 text-center">
      <button mat-raised-button class="btn-success mr-1" (click)="activeModal.close('Si')">Si</button>
      <button mat-raised-button class="btn-danger" (click)="activeModal.dismiss('No')">No</button>
    </div>
  </div>
</div>



